
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
const UploadHeader = ({ title,btn }) => {
  return (
    <Box
      sx={{
        bgcolor: "common.black",
        color: "#fff",
        p: 2,
        alignItems: "center",
        justifyContent: "space-between",
         display:"flex"
      }}
      className="header"
     
      
    >
      <Typography variant="h6" component="div">
        {title}
      </Typography>
      {btn.show && (
          <Button type="button" sx={{ mr: 4 }} variant={btn.type} onClick={btn.callBack}>
            {btn.text}
          </Button>
        )}

      
    </Box>
  );
};
export default UploadHeader;
